import React from "react";
import { Target, HandHeart, Star } from "lucide-react";

const MissionVisionCard = () => {
  const sections = [
    "প্রধানত সামাজিক ও শিক্ষা কর্মকাণ্ড পরিচালনা করবে।",
    "এলাকাবাসির মধ্যে আত্মনির্ভরশীলতা অর্জনের প্রত্যয় সৃষ্টি করা।",
    "এলাকার গরীব, অসহায় মেধাবী ছাত্র-ছাত্রীদের পড়া লেখা চালিয়ে যেতে সহায়তা বা উদ্ভুদ্ব করা এবং বিনামুল্যে বই বিতরন করা।",
    "ছাত্র-ছাত্রীদের মেধা ও সৃজনশীলতার সর্বাধিক বিকাশের লক্ষ্যে তাদেরকে প্রণোদিত ও সংগঠিত করা ও মেধাবী ছাত্র ছাত্রীদেরকে উপবৃত্তি প্রদান করা।",
    "রমজান মাসে অসহায় গরিবদের মাঝে ইফতারি সামগ্রী বিতরন করা ও ইফতার মাহফিল আয়োজন করা।",
    "ঈদ উৎসব ঈদের আগের দিন অসহায় গরিবের মাঝে ঈদ প্যাকেজ বিতরন করা।",
    "সমাজের সবার মধ্যে সামাজিক দায়বদ্ধতা বোধ সৃষ্টি করে সমাজ সচেতন নাগরিক হিসেবে গড়ে তোলা।",
    "পূর্ব বড়ুয়া তরুন সংঘ সামাজিক সংগঠনের প্রতিটি সদস্যকে কাজের মাধ্যমে সফল, স্বয়ংক্রিয় ও স্বেচ্ছাসেবী হয়ে ওঠার লক্ষ্যে ক্ষমতায়িত করা।",
    "শিশু কল্যাণঃ এলাকার গরীব শিশু-কিশোরদের অক্ষরদান দেয়ার জন্য গণশিক্ষা কেন্দ্র/পাঠাগার প্রতিষ্ঠা করা এবং দরিদ্র শিশুদের খেলাধুলার পাশাপাশি সু-স্বাস্থ্য নিশ্চিত কল্পে ফ্রি চিকিৎসার ব্যবস্থা করা এবং শিশুদের বাল্যবিবাহ রোধে সভা-সেমিনার ও গনসচেতনতা সৃষ্টি করা।",
    "এলাকার সকল প্রকার খেলাধুলার আয়োজন, অংশগ্রহন ও প্রতিভাবান খেলোয়ারদের প্রশিক্ষন এর ব্যাবস্থা করা। সংশ্লিস্ট খেলায় জেলা, বিভাগ ও জাতীয় পর্যায়ে অংশ গ্রহন করার ব্যবস্থা করা।",
    "মাদক মুক্ত এলাকা গড়তে প্রশাসনকে সহযোগিতা করা।",
    "এলাকার মাদকাসক্ত, জুয়াড়ি, বখাটে ও অপরাধীদের সুস্থ জীবনে ফিরিয়ে আনার লক্ষে বিনোদন, গনসচেতনতা ও চিকিৎসার ব্যাবস্থা করা এবং কর্মসংস্থানের জন্য উৎসাহ প্রদান করা।",
    "সমাজ বিরোধী কার্যকলাপ হইতে জনগণকে বিরত রাখিবার উদ্দেশ্যে চিত্ত-বিনোদন ও সাংস্কৃতিক কর্মসূচীর ব্যবস্থা করা।",
    "যে কোন সেবামূলক কাজে জনগনকে উদ্ভুদ্ব করা এবং জনগনকে সেবামূলক কাজে সহযোগিতা করা। এমনকি খাদ্য দ্রব্যকে বিষ মুক্ত রাখা ও কৃষকদেরকে কেমিক্যাল ব্যতিত ফসল উৎপাদানের ব্যপারে পরামর্শ দেয়া।",
    "সরকারের উন্নয়ন মূলক সংস্থা সমূহের সহায়ক শক্তি হিসাবে কাজ করা। গণ-শিক্ষা গ্রহণে বয়স্কদের উদ্ভুদ্ব করা, উন্নত প্রযুক্তির কৃষি, মৎস্য চাষ, হাঁস মুরগী পালন, হস্ত ও কুটির শিল্প স্থাপন, হেচারী ও নার্সারী সহ অন্যান্য কার্যক্রম সম্মন্ধে গ্রামবাসীর মধ্যে জ্ঞান দানের নিমিত্তে সংশ্লিষ্ট উন্নয়ন মূলক কর্মকান্ডে আমন্ত্রন করা এবং সভা ও সেমিনারের আয়োজন করা।পরিবার পরিকল্পনার মাঠকর্মীদের সাথে সমন্বয় সাধন করে পরিকল্পিত পরিবার গঠনে জনগনকে উদ্ধুদ্ধ করা।",
    "দেশের দুর্ভিক্ষ, বন্যা, ঘুর্ণিঝড়, ভূমিকম্প, মহামারী, অনাবৃষ্টি, অতিবৃষ্টি, সকল প্রকার প্রাকৃতিক দুর্যোগে সাহায্য সামগ্রী নিয়ে দুঃস্হ, ও ক্ষতিগ্রস্থদের পাশে এগিয়ে যাওয়া শীত বস্ত্র বিতরন এবং তহিবল বৃদ্ধি ও সংরক্ষনার্থে দান।",
    "ফুটবল, ক্রিকেট বেটমিন্টন টুর্নামেন্ট ও সাংস্কৃতিক অনুষ্ঠানের আয়োজন করা।",
  ];

  // Group sections into categories to improve organization
  const categoryGroups = [
    {
      title: "শিক্ষা ও উন্নয়ন",
      icon: <Target className="w-8 h-8 text-blue-600" />,
      color: "bg-blue-100 border-blue-500",
      sections: [0, 1, 2, 3, 7, 8, 9],
    },
    {
      title: "সামাজিক সেবা",
      icon: <HandHeart className="w-8 h-8 text-emerald-600" />,
      color: "bg-emerald-100 border-emerald-500",
      sections: [4, 5, 6, 15, 16],
    },
    {
      title: "সচেতনতা ও সংস্কৃতি",
      icon: <Star className="w-8 h-8 text-amber-600" />,
      color: "bg-amber-100 border-amber-500",
      sections: [10, 11, 12, 13, 14, 17],
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-4 md:p-8">
      <div className="max-w-5xl mx-auto">
        {/* Header Card */}
        <div className="card bg-gradient-to-r from-primary to-secondary text-white shadow-xl mb-8">
          <div className="card-body text-center py-10">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-2">
              লক্ষ্য ও উদ্দেশ্য
            </h1>
            <p className="text-lg opacity-90">নিঃস্বার্থ নবজীবন সংগঠন (NNS)</p>
            <div className="mt-4 flex flex-wrap justify-center gap-2">
              <div className="badge badge-outline">শিক্ষা</div>
              <div className="badge badge-outline">উন্নয়ন</div>
              <div className="badge badge-outline">মানব সেবা</div>
              <div className="badge badge-outline">সামাজিক দায়িত্ব</div>
            </div>
          </div>
        </div>

        {/* Introduction */}
        <div className="card bg-white shadow-lg mb-8">
          <div className="card-body">
            <p className="text-gray-700 text-lg">
              আমরা ভালবাসা, আশা এবং সামাজিক ন্যায়বিচার সমবেত একটি পৃথিবীর
              স্বপ্ন দেখি, যেখানে মানুষ মর্যাদা ও নিরাপত্তা নিয়ে বাস করবে।
              সমাজের অনগ্রসর শ্রেণীকে বিশেষভাবে চরম দরিদ্র, গৃহহীন ও অনাথ
              শিশুদেরকে শিক্ষা, পুষ্টি ও আশ্রয় সরবরাহের মাধ্যমে তাদের জাতির
              জন্য সম্পদে পরিণত করা আমাদের প্রধান লক্ষ্য।
            </p>
          </div>
        </div>

        {/* Category Tabs */}
        <div className="tabs tabs-boxed justify-center mb-6">
          {categoryGroups.map((group, idx) => (
            <a
              key={idx}
              className={`tab ${idx === 0 ? "tab-active" : ""}`}
              onClick={() =>
                document
                  .getElementById(`category-${idx}`)
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              {group.title}
            </a>
          ))}
        </div>

        {/* Main Content */}
        <div className="space-y-12">
          {categoryGroups.map((category, categoryIndex) => (
            <div
              id={`category-${categoryIndex}`}
              key={categoryIndex}
              className="scroll-mt-4"
            >
              <div className="flex items-center gap-3 mb-4">
                {category.icon}
                <h2 className="text-2xl font-bold text-gray-800">
                  {category.title}
                </h2>
              </div>

              <div className="grid grid-cols-1 gap-4">
                {category.sections.map((sectionIdx) => (
                  <div
                    key={sectionIdx}
                    className={`card ${category.color} border-l-4 hover:shadow-md transition-shadow duration-300`}
                  >
                    <div className="card-body p-4">
                      <p className="text-gray-800 text-lg">
                        {sections[sectionIdx]}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Footer Call to Action */}
        <div className="card bg-gradient-to-r from-gray-800 to-gray-900 text-white mt-12">
          <div className="card-body text-center">
            <h3 className="text-xl font-bold mb-3">আমাদের সাথে যোগ দিন</h3>
            <p>এই উদ্দেশ্য বাস্তবায়নে আপনার সহযোগিতা আমরা সাদরে গ্রহণ করব।</p>
            <div className="mt-4">
              <button className="btn btn-outline btn-sm btn-success mr-2">
                সদস্য হোন
              </button>
              <button className="btn btn-outline btn-sm btn-info">
                আরও জানুন
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionVisionCard;
